<template>
	<div class="main">
    <div class="Logistics">
      <div class="back global_pointer" @click="goBack">
			<img src="@/assets/imgs/nav_left_icon_back.png" />
		</div>
		<div class="process" v-if="logisticsData.logisticsProcess">
			<div v-for="(item, index) in logisticsData.logisticsProcess" :key="index">
				<div class="process-context">
					<div v-if="index != 0" class="process-line"></div>
					<div class="process-content">
						<div v-if="index != logisticsData.logisticsProcess.length - 1">
							<img
							
							src="@/assets/imgs/logistics/done.png"
						/>
						<div class="process-content-text">{{ item }}</div>
						</div>
						<div  v-else>

						<div class="process-content-num">{{ index + 1 }}</div>
						<div class="process-content-text process-content-text-last">{{ item }}</div>
						</div>
						
					</div>
				</div>
			</div>
		</div>
		<div class="logistics" v-if="logisticsData">
			<div v-if="logisticsData.logisticsInquiryMain">
				<div class="logistics-status">
					{{ logisticsData.logisticsInquiryMain.logisticsType }}
				</div>
				<div class="logistics-type">
					<img src="@/assets/imgs/logistics/logistics-icon.png" />
					<div>
						<div class="logistics-type-text">
							{{ $t("message.logistics.company") }}：{{
								logisticsData.logisticsInquiryMain.company
							}}
						</div>
						<div class="logistics-type-text">
							{{ $t("message.logistics.trackno") }}：{{
								logisticsData.logisticsInquiryMain.trackNo
							}}
						</div>
					</div>
				</div>

				<div class="logistics-detail">
					<img
						v-if="logisticsData.logisticsInquiryMain.state == 1"
						class="logistics-done"
						src="@/assets/imgs/logistics/all-done.png"
					/>
					<template
						v-for="(trajectory, tindex) in logisticsData.logisticsInquiryMain
							.trajectory"
					>
						<div class="logistics-context" :key="tindex">
							<div class="line">
								<div :class="tindex == 0 ? 'line-t' : 'line-t line-t-c'"></div>
								<div class="point"></div>
								<div
									:class="
										tindex !=
										logisticsData.logisticsInquiryMain.trajectory.length - 1
											? 'line-b'
											: ''
									"
								></div>
							</div>
							<div class="logistics-right">
								<div>{{  $moment(new Date(trajectory.time)).format('yyyy-MM-DD HH:mm:ss') }}</div>
								<div>{{ trajectory.context }}</div>
							</div>
						</div>
					</template>
				</div>
			</div>
      <template v-if="logisticsData.logisticsInquiryBusi">
        <div
          v-for="(item, index) in logisticsData.logisticsInquiryBusi"
          :key="index">
          <div :class="index != 0 ? 'logistics-type-line' : ''"></div>
          <div class="logistics-type">
            <img :src="getLogisticsTypeIcon(index)" />
            <div class="logistics-type-text">{{ item.logisticsType }}</div>
          </div>
        </div>
      </template>
		</div>
    </div>
		
	</div>
</template>

<script>
import api from "@/api/api_list";
import { getDeviceId } from '@/utils';

export default {
	components: {},
	data() {
		return {
			logisticsData: {},
		};
	},
	computed: {},
	created() {
		if (this.$route.query.orderMcId) {
			this.getLogistics();
		}
	},
	methods: {
		goBack() {
			this.$router.back(-1);
		},
		getLogisticsTypeIcon(index) {
			let imgs = [
				require("@/assets/imgs/logistics/buy-done.png"),
				require("@/assets/imgs/logistics/buy-doing.png"),
				require("@/assets/imgs/logistics/wait-buy.png"),
			];
			let i = this.logisticsData.logisticsInquiryBusi
				? 3 - this.logisticsData.logisticsInquiryBusi.length + index
				: index;
			return imgs[i];
		},
		// 获取订单详情
		async getLogistics() {
			const defaultData = {
				anonymousId: this.$sa.store.getDistinctId() || '',
				appVersion: '0.0.0',
				deviceId: getDeviceId(),
				deviceModel: null,
				deviceSystem: 4,
				deviceVersion: '0.0.0',
				loginIp: null,
			};
			let { code, result } = await api.get_logistics({
				...defaultData,
				orderMcId: this.$route.query.orderMcId,
			});

			if (!code) {
				if (
					result.logisticsInquiryResultList &&
					result.logisticsInquiryResultList.length > 0
				) {
					let logisticsData = result;
					let logisticsInquiry = logisticsData.logisticsInquiryResultList[0];
					if (logisticsInquiry.trackNo) {
						logisticsData.logisticsInquiryMain = logisticsInquiry;
						logisticsData.logisticsInquiryBusi = [];
						for (
							let index = 0;
							index < logisticsData.logisticsInquiryResultList.length;
							index++
						) {
							if (index > 0) {
								const element = logisticsData.logisticsInquiryResultList[index];
								logisticsData.logisticsInquiryBusi.push(element);
							}
						}
					} else {
						logisticsData.logisticsInquiryBusi =
							logisticsData.logisticsInquiryResultList;
					}
					this.logisticsData = logisticsData;
				}
			}
		},
	},
};
</script>

<style lang="less" scoped>
.main {
	background-color: #f4f7f7;
    font-family: "TradeGothicLT";
	.back {
		display: flex;
		margin: 8px;
		img {
			width: 28px;
			height: 28px;
		}
	}
}
.process {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	padding: 19px 0 19px 0;
	background-color: white;
	&-context {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	&-line {
		background-color: #e5e8e8;
		width: 30px;
		height: 0.5px;
		margin-top: -20px;
	}
	&-content {
		margin-left: 2.5px;
		img {
			width: 22px;
			height: 22px;
		}
		&-text {
			width: 46px;
			text-align: center;
			color: #999999;
			&-last{

			color: #39d2d6;
			}
		}
		&-num {
			width: 22px;
			height: 22px;
			border-radius: 50%;
			line-height: 22px;
			margin: auto;
      		margin-bottom: 3px;
			color: white;
			background-color: #39d2d6;

		}
	}
}
.logistics {
	margin-top: 12px;
	background-color: white;
	text-align: left;
	padding: 14px 12px;
	&-done {
		width: 28px;
		height: 28px;
		left: 2px;
		position: absolute;
	}
	&-status {
		display: inline-block;
		margin-right: auto;
		margin-top: 8px;
		margin-bottom: 14px;
		padding: 0 5px;
		color: #39d2d6;
		background-color: rgba(57, 210, 214, 0.1);
		border-radius: 34px;
	}
	&-detail {
		position: relative;
		margin: 8px 0;
	}
	&-type {
		display: flex;
		flex-direction: row;
		color: #5a5a5a;
		font-size: 13px;
		img {
			width: 20px;
			height: 20px;
			margin-right: 8px;
		}
		&-line {
			margin-top: 13px;
			margin-bottom: 13px;
			margin-left: 14px;
			width: 0.5px;
			background-color: #e5e8e8;
			height: 50px;
		}
	}
	&-context {
		display: flex;
		flex-direction: row;
	}
	&-right {
		color: #a4a4a4;
		font-size: 13px;
		margin-left: 30px;
		padding-bottom: 20px;
	}

	.line {
		&-t {
			margin-left: 14px;
			width: 0.5px;
			height: 2.5px;
			&-c {
				background-color: #e5e8e8;
			}
		}

		.point {
			width: 8px;
			height: 8px;
			background-color: #e5e8e8;
			border-radius: 50%;
			margin-left: 10px;
		}
		&-b {
			margin-left: 14px;
			background-color: #e5e8e8;
			width: 0.5px;
			margin-bottom: 0;
			height: 100%;
		}
	}
}
</style>
